<template>
  <v-card class="mx-auto text-left elevation-8" tile>
    <v-img
      height="100%"
      :src="person.bg_url"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
    >
      <v-row align="end" class="fill-heightx" no-gutters>
        <v-col align-self="start" class="pa-0" no-gutters cols="5">
          <v-avatar class="profile" color="grey" size="100%" tile>
            <v-img
              :src="person.profile_picture"
              style="width: 100%; height: 190px"
            ></v-img>
          </v-avatar>
        </v-col>
        <v-col align="stretch" cols="7" class="pb-0 pl-0">
          <div
            class="primish pb-2 pl-2 pt-2 white--text"
            v-html="person.description"
          ></div>
        </v-col>
      </v-row>
      <v-row align="end" class="fill-heightx pa-0 ma-0 primish" no-gutters>
        <v-col align-self="start" class="pa-0 ma-0 " no-gutters cols="5">
          <div class="py-0x " style="bac">
            <v-list-item color="rgba(0, 0, 0, .4)" dark>
              <v-list-item-content>
                <v-list-item-title class="title">{{person.name}}</v-list-item-title>
                <v-list-item-subtitle>{{ person.role }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-col>
        <v-col align="stretch" cols="7" no-gutters  class="pb-0 pl-0">
          <div class=" pb-2 pl-2 pt-4 pr-2 text-right">
            <v-btn
              class="mr-1 mt-1"
              :href="person.facebook_url"
              target="_blank"
              dense
              icon
              large
              outlined
              color="success"
            >
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              class="mr-1 mt-1"
              :href="person.instagram_url"
              target="_blank"
              dense
              icon
              large
              outlined
              color="success"
            >
              <v-icon>mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              class="mr-1 mt-1"
              :href="'mailto:' + person.email_address"
              target="_blank"
              dense
              icon
              large
              outlined
              color="success"
            >
              <v-icon>mdi-email-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: "ProfileCard",
  props: {
    person: {
      type: Object,
      default: () => {
        return {
          profile_picture:
            "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601751884/botswana%20services/website%20assets/default-avatar_pain2e.png",
          name: "",
          role: "",
          description: "",
          facebook_url: "",
          instagram_url: "",
          email_address: "",
          bg_url: "https://cdn.vuetifyjs.com/images/cards/server-room.jpg",
        };
      },
    },
  },
};
</script>

